import { useKeycloak } from "@react-keycloak/web";
import { useQueryClient } from "@tanstack/react-query";
import {
  useUpdateTemplate
} from "../../tanstackQuery/queries/templates";

export const WithTemplates = (Component: any) => (props: any) => {
  const { keycloak } = useKeycloak();

  const client = useQueryClient();
  const { mutateAsync: updateTemplate } = useUpdateTemplate(
    {
      accessToken: keycloak?.token
    },
    {
      onSuccess() {
        client.invalidateQueries({ queryKey: ["templates"] });
      }
    }
  );

  return <Component {...props} {...{ updateTemplate }} />;
};
